import { Link as RouterLink } from "react-router-dom"
import { Button, Link, Paper, Stack, Typography } from "@mui/material"
import { LocalPhone, LocationOn, MailOutline, OpenInNew } from "@mui/icons-material"

import { OFFICE_ADDRESS_SHORT, MAPS_SEARCH_URL } from "../../../constants/address"
import { EMAIL_HREF, PHONE_HREF } from "../../../constants/contactInfo"
import { pillButtonSx } from "../../../styles/sectionStyles"

const OfficeCard = ({ fleetCount, sx }) => (
    <Paper
        variant="outlined"
        sx={{
            p: 2.5,
            borderRadius: 2,
            borderColor: "rgba(0, 4, 53, 0.08)",
            bgcolor: "#fff",
            position: "relative",
            ...sx,
        }}
    >
        <Typography variant="subtitle1" fontWeight={800} color="#000435" gutterBottom>
            Stargate Rentals
        </Typography>
        <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 1.5 }}>
            <LocationOn sx={{ fontSize: 18, color: "secondary.main", mt: 0.2 }} />
            <Typography variant="body2" color="text.secondary" lineHeight={1.6}>
                {OFFICE_ADDRESS_SHORT}
            </Typography>
        </Stack>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 2 }}>
            <Button
                component={Link}
                href={MAPS_SEARCH_URL}
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                endIcon={<OpenInNew sx={{ fontSize: 16 }} />}
                sx={{ textTransform: "none", fontWeight: 700 }}
            >
                View on map
            </Button>
            <Button
                component={RouterLink}
                to="/vehicles"
                size="small"
                sx={{ textTransform: "none", fontWeight: 700 }}
            >
                {fleetCount} vehicle{fleetCount === 1 ? "" : "s"} for hire
            </Button>
        </Stack>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
            <Button component={Link} href={PHONE_HREF} variant="outlined" size="small" startIcon={<LocalPhone />} sx={pillButtonSx}>
                Call
            </Button>
            <Button component={Link} href={EMAIL_HREF} variant="outlined" size="small" startIcon={<MailOutline />} sx={pillButtonSx}>
                Email
            </Button>
        </Stack>
    </Paper>
)

export default OfficeCard
